var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{on:{"language-changed":_vm.onLanguageChanged}}),_c('router-view'),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }